const AUTH_MESSAGES: Record<string, string> = {
  not_allowed:
    "That Google account isn't on the board yet. Ask an admin to add your email, then try again.",
  bad_state: "That sign-in link expired. Give it another go.",
  exchange_failed: "Google couldn't complete the sign-in. Try again in a moment.",
  access_denied: "Sign-in was cancelled.",
};

export function SignIn() {
  const error = new URLSearchParams(window.location.search).get("auth_error");
  const message = error ? (AUTH_MESSAGES[error] ?? "Sign-in failed. Try again.") : null;

  return (
    <main className="signin">
      <div className="signin__card">
        <img className="signin__brand" src="/smrt-board.png" alt="smrt board" />
        <p className="signin__tagline">Client work, up on the wall.</p>
        {message ? (
          <p className="notice" role="alert">
            {message}
          </p>
        ) : null}
        <a className="signin__button" href="/auth/google">
          <GoogleMark />
          Continue with Google
        </a>
      </div>
    </main>
  );
}

function GoogleMark() {
  return (
    <svg width="17" height="17" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.6 9.2c0-.6-.1-1.2-.2-1.8H9v3.5h4.8a4.1 4.1 0 0 1-1.8 2.7v2.2h2.9c1.7-1.6 2.7-3.9 2.7-6.6Z" />
      <path fill="#34A853" d="M9 18c2.4 0 4.5-.8 6-2.2l-2.9-2.2c-.8.5-1.8.9-3.1.9-2.4 0-4.4-1.6-5.1-3.8H.9v2.3A9 9 0 0 0 9 18Z" />
      <path fill="#FBBC05" d="M3.9 10.7a5.4 5.4 0 0 1 0-3.4V5H.9a9 9 0 0 0 0 8l3-2.3Z" />
      <path fill="#EA4335" d="M9 3.6c1.3 0 2.5.5 3.4 1.3L15 2.3A9 9 0 0 0 .9 5l3 2.3C4.6 5.2 6.6 3.6 9 3.6Z" />
    </svg>
  );
}
